import { Component, Input, OnInit } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { NgClass, NgForOf } from '@angular/common'
import {
  GamePlayPlayer,
  gamePlayPlayerNull,
  playerScoreCardNull,
} from 'game-play-services'

@Component({
  selector: 'sans-game-scores',
  standalone: true,
  templateUrl: './game-scores.component.html',
  styleUrl: './game-scores.component.scss',
  imports: [MatIcon, NgClass, NgForOf],
})
export class GameScoresComponent implements OnInit {
  @Input() public user: GamePlayPlayer = gamePlayPlayerNull
  @Input() public rightOpponent: GamePlayPlayer = gamePlayPlayerNull
  @Input() public leftOpponent: GamePlayPlayer = gamePlayPlayerNull

  @Input() public userPlayerScoreCard = playerScoreCardNull
  @Input() public leftOpponentPlayerScoreCard = playerScoreCardNull
  @Input() public rightOpponentPlayerScoreCard = playerScoreCardNull

  private showUserScoresAriaLabel = $localize`:Dashboard component|Show user scores:Show user scores`
  private showLeftPlayerScoresAriaLabel = $localize`:Dashboard component|Show left player aria label:Show left player scores`
  private showRightPlayerScoresAriaLabel = $localize`:Dashboard component|Show right player aria label:Show right player scores`

  public isShowingLeftOpponentScores = false
  public isShowingRightOpponentScores = false
  public isShowingUserScores = true

  public centerPlayerUsername = ''
  public centerPlayerPoolPoints: number[] = []

  public rightPlayerScoresAriaLabel = this.showRightPlayerScoresAriaLabel
  public rightPlayerScoresIcon = 'arrow_right'
  public rightPlayerUsername = ''
  public rightPlayerWhistPoints: number[] = []

  public leftPlayerScoresAriaLabel = this.showLeftPlayerScoresAriaLabel
  public leftPlayerScoresIcon = 'arrow_left'
  public leftPlayerUsername = ''
  public leftPlayerWhistPoints: number[] = []

  public ngOnInit(): void {
    this.initializeGameScores()
  }

  public onShowLeftPlayerScoresIconSelected(): void {
    if (this.isShowingLeftOpponentScores) {
      return
    }

    this.isShowingRightOpponentScores = false
    this.rightPlayerScoresIcon = 'arrow_right'

    if (this.isShowingUserScores) {
      this.isShowingLeftOpponentScores = true
      this.isShowingUserScores = false
      this.leftPlayerScoresIcon = ''
      this.leftPlayerScoresAriaLabel = ''
      this.rightPlayerScoresAriaLabel = this.showUserScoresAriaLabel
      this.centerPlayerUsername = this.leftOpponent.username
      this.leftPlayerUsername = this.rightOpponent.username
      this.rightPlayerUsername = this.user.username

      this.centerPlayerPoolPoints = this.leftOpponentPlayerScoreCard.poolPoints
      this.leftPlayerWhistPoints =
        this.leftOpponentPlayerScoreCard.leftPlayerWhistPoints
      this.rightPlayerWhistPoints =
        this.leftOpponentPlayerScoreCard.rightPlayerWhistPoints

      return
    }

    this.isShowingLeftOpponentScores = false
    this.isShowingUserScores = true
    this.leftPlayerScoresIcon = 'arrow_left'
    this.leftPlayerScoresAriaLabel = this.showLeftPlayerScoresAriaLabel
    this.rightPlayerScoresAriaLabel = this.showRightPlayerScoresAriaLabel
    this.initializeGameScores()
  }

  public onShowRightPlayerScoresIconSelected(): void {
    if (this.isShowingRightOpponentScores) {
      return
    }

    this.isShowingLeftOpponentScores = false
    this.leftPlayerScoresIcon = 'arrow_left'

    if (this.isShowingUserScores) {
      this.isShowingUserScores = false
      this.isShowingRightOpponentScores = true
      this.rightPlayerScoresIcon = ''
      this.leftPlayerScoresAriaLabel = this.showUserScoresAriaLabel
      this.rightPlayerScoresAriaLabel = ''
      this.centerPlayerUsername = this.rightOpponent.username
      this.leftPlayerUsername = this.user.username
      this.rightPlayerUsername = this.leftOpponent.username

      this.centerPlayerPoolPoints = this.rightOpponentPlayerScoreCard.poolPoints
      this.leftPlayerWhistPoints =
        this.rightOpponentPlayerScoreCard.leftPlayerWhistPoints
      this.rightPlayerWhistPoints =
        this.rightOpponentPlayerScoreCard.rightPlayerWhistPoints

      return
    }

    this.isShowingUserScores = true
    this.isShowingRightOpponentScores = false
    this.rightPlayerScoresIcon = 'arrow_right'
    this.leftPlayerScoresAriaLabel = this.showLeftPlayerScoresAriaLabel
    this.rightPlayerScoresAriaLabel = this.showRightPlayerScoresAriaLabel
    this.initializeGameScores()
  }

  private initializeGameScores(): void {
    this.centerPlayerUsername = this.user.username
    this.leftPlayerUsername = this.leftOpponent.username
    this.rightPlayerUsername = this.rightOpponent.username

    this.centerPlayerPoolPoints = this.userPlayerScoreCard.poolPoints
    this.leftPlayerWhistPoints = this.userPlayerScoreCard.leftPlayerWhistPoints
    this.rightPlayerWhistPoints =
      this.userPlayerScoreCard.rightPlayerWhistPoints
  }
}
